import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "../Loadable";

const FundTransfer = Loadable(
  lazy(() => import("src/pages/user/financial/fundTransfer"))
);

const MyEarnings = Loadable(
  lazy(() => import("src/pages/user/financial/ewallet"))
);

const CashWallet = Loadable(
  lazy(() => import("src/pages/user/financial/cash-wallet"))
);

// const BtcRewardsWallet = Loadable(
//   lazy(() => import("src/pages/user/financial/btc-rewards-wallet"))
// );

// const PendingCommission = Loadable(
//   lazy(() => import("src/pages/user/financial/pending"))
// );

const DepositWallet = Loadable(
  lazy(() => import("src/pages/user/financial/deposit"))
);

const AddCredit = Loadable(
  lazy(() => import("src/pages/user/financial/deposit/addCredit"))
);

const RequestPayout = Loadable(
  lazy(() => import("src/pages/user/financial/requestPayout/index"))
);

const BinaryCommission = Loadable(
  lazy(() => import("src/pages/user/financial/binary-commission/list/index"))
);
const BinaryCommissionDetails = Loadable(
  lazy(() => import("src/pages/user/financial/binary-commission/details/index"))
);

const CommissionPeriod = Loadable(
  lazy(() => import("src/pages/user/financial/commission-period/index"))
);

const PartnerRewards = Loadable(
  lazy(() => import("src/pages/user/financial/partner-rewards/index"))
);

const SalesRepresantative = Loadable(
  lazy(() => import("src/pages/user/financial/sales-represantative/index"))
);

const EwalletTransactionHistory = Loadable(
  lazy(() => import("src/pages/user/financial/ewallet/components/TransactionHistory"))
);

const financial = {
  path: "financial",
  children: [
    { index: true, element: <Navigate to="my-earnings" /> },
    { path: "ewallet", element: <MyEarnings /> },
    // { path: "pending-commission", element: <PendingCommission /> },
    {
      path: "deposit-wallet",
      children: [
        { index: true, element: <DepositWallet /> },
        { path: "add-credit", element: <AddCredit /> },
      ],
    },
    {
      path: "binary-commission",
      children: [
        { index: true, element: <BinaryCommission /> },
        {
          path: ":id",
          element: <BinaryCommissionDetails />,
        },
      ],
    },
    { path: "cash-wallet", element: <CashWallet /> },
    // { path: "btc-rewards-wallet", element: <BtcRewardsWallet /> },
    { path: "funds-transfer", element: <FundTransfer /> },
    { path: "payout", element: <RequestPayout /> },
    { path: "commission-period", element: <CommissionPeriod />},
    { path: "partner-rewards", element: <PartnerRewards /> },
    { path: "sales-represantative", element: <SalesRepresantative /> },
    { path: "ewallet-transaction-history", element: <EwalletTransactionHistory /> },
  ],
};

export default financial;
